import React, { useState } from "react";

export default function RefractionGlassSlab({ onComplete }) {
  const [angle, setAngle] = useState(30);

  const rad = (angle * Math.PI) / 180;

  // INCIDENT RAY COORDINATES
  const incidentStartX = 100;
  const incidentStartY = 200;

  const hitX = 300; // entry point on slab
  const hitY = 200;

  const incidentEndX = hitX - Math.cos(rad) * 120;
  const incidentEndY = hitY - Math.sin(rad) * 120;

  // REFRACTED RAY INSIDE SLAB
  const slabExitX = 460;
  const slabExitY = hitY - Math.sin(rad) * 40;

  // EMERGENT RAY (parallel to incident)
  const emergentEndX = slabExitX + Math.cos(rad) * 140;
  const emergentEndY = slabExitY + Math.sin(rad) * 140;

  return (
    <div className="flex flex-col items-center mt-10 px-4">
      <h2 className="text-3xl font-bold text-green-700 mb-6">
        Refraction Through Glass Slab
      </h2>

      <div
        className="relative border bg-white rounded shadow"
        style={{ width: "100%", maxWidth: "900px", height: "400px" }}
      >
        {/* LABELS */}
        <div className="absolute left-[260px] top-[40px] text-xs font-semibold text-gray-700">
          Normal
        </div>
        <div className="absolute left-[410px] top-[40px] text-xs font-semibold text-gray-700">
          Normal
        </div>
        <div className="absolute left-[305px] top-[90px] text-sm font-bold text-blue-800">
          Glass Slab
        </div>

        {/* GLASS SLAB */}
        <div className="absolute left-[300px] top-[80px] w-[160px] h-[240px] bg-blue-100 border-4 border-blue-400 opacity-70 rounded">
        </div>

        {/* NORMAL LINES */}
        <svg className="absolute w-full h-full">
          <line
            x1={300}
            y1={40}
            x2={300}
            y2={360}
            stroke="gray"
            strokeWidth="2"
            strokeDasharray="6"
          />
          <line
            x1={460}
            y1={40}
            x2={460}
            y2={360}
            stroke="gray"
            strokeWidth="2"
            strokeDasharray="6"
          />

          {/* INCIDENT RAY */}
          <line
            x1={incidentEndX}
            y1={incidentEndY}
            x2={hitX}
            y2={hitY}
            stroke="red"
            strokeWidth="4"
          />
          <text
            x={(incidentEndX + hitX) / 2 - 40}
            y={(incidentEndY + hitY) / 2 - 10}
            fill="red"
            fontSize="14"
            fontWeight="bold"
          >
            Incident Ray
          </text>

          {/* REFRACTED RAY */}
          <line
            x1={hitX}
            y1={hitY}
            x2={slabExitX}
            y2={slabExitY}
            stroke="orange"
            strokeWidth="4"
          />
          <text
            x={(hitX + slabExitX) / 2}
            y={(hitY + slabExitY) / 2 - 10}
            fill="orange"
            fontSize="14"
            fontWeight="bold"
          >
            Refracted Ray
          </text>

          {/* EMERGENT RAY */}
          <line
            x1={slabExitX}
            y1={slabExitY}
            x2={emergentEndX}
            y2={emergentEndY}
            stroke="green"
            strokeWidth="4"
          />
          <text
            x={(slabExitX + emergentEndX) / 2}
            y={(slabExitY + emergentEndY) / 2 - 10}
            fill="green"
            fontSize="14"
            fontWeight="bold"
          >
            Emergent Ray
          </text>

          {/* POINTS */}
          <circle cx={hitX} cy={hitY} r="6" fill="red" />
          <text x={hitX + 10} y={hitY + 20} fill="red" fontSize="12">
            Entry Point
          </text>

          <circle cx={slabExitX} cy={slabExitY} r="6" fill="green" />
          <text x={slabExitX + 10} y={slabExitY + 20} fill="green" fontSize="12">
            Exit Point
          </text>
        </svg>
      </div>

      {/* CONTROLS */}
      <div className="mt-6 w-full max-w-[600px] p-5 bg-gray-50 rounded shadow">
        <label className="block font-semibold text-lg mb-2">
          Angle of Incidence: {angle}°
        </label>

        <input
          type="range"
          min={5}
          max={80}
          value={angle}
          onChange={(e) => {
            setAngle(+e.target.value);
            onComplete && onComplete();
          }}
          className="w-full"
        />
      </div>
    </div>
  );
}
